module.exports = __webpack_public_path__ + "static/media/Qpayments.7828a7dd.jpeg";